import { useTranslation } from 'react-i18next';
import Logo from './logo';

export default function Footer() {
	const { t } = useTranslation();

	return (
		<footer>
			<div className="mx-auto max-w-6xl px-4 sm:px-6">
				{/* Blocks */}
				<div className="grid gap-8 py-8 sm:grid-cols-12 md:py-12">
					{/* 1st block */}
					<div className="order-1 sm:col-span-12 lg:order-none lg:col-span-4">
						<div className="flex h-full flex-col justify-between sm:flex-row lg:flex-col">
							<div className="mb-4 sm:mb-0">
								<div className="mb-4">
									<Logo />
								</div>
								<div className="text-sm text-slate-300">© explorabit.com</div>
							</div>
						</div>
					</div>

					{/* 3rd block */}
					<div className="sm:col-span-6 md:col-span-3 lg:col-span-2">
						<h6 className="mb-2 text-sm font-medium text-slate-50">
							{t('footer.company')}
						</h6>
						<ul className="space-y-2 text-sm">
							<li>
								<a
									className="text-slate-400 transition duration-150 ease-in-out hover:text-slate-200"
									href="about"
								>
									{t('footer.about')}
								</a>
							</li>
							<li>
								<a
									className="text-slate-400 transition duration-150 ease-in-out hover:text-slate-200"
									href="contact"
								>
									{t('footer.join')}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
}
